<script setup lang="ts">
import DraggableFormList from '@/core/components/form-elements/DraggableFormList.vue';
import LanguageTabs from '@/core/components/layout-elements/LanguageTabs.vue';
import { createDefaultLocation } from '@/modules/content-blocks/helpers/location-block.helper';
import { NxtInput, NxtPhoneNumberInput } from '@future-harry/nxt-styles';
import { Address } from '@future-harry/nxt-vue-library';
import NxtAddressField from '@/core/components/form-elements/NxtAddressField.vue';

const model = defineModel<any>();

const props = defineProps<{
   errors: Record<string, string>;
}>();

const normalizeAddress = (address: Partial<Address> | null | undefined): Address => {
   const normalizedAddress = address ?? {};

   return {
      ...normalizedAddress,
      city: normalizedAddress.city ?? {},
   } as Address;
};

const addLocation = (data: any) => {
   data.locations.push(createDefaultLocation());
};

const removeLocation = (data: any, id: string) => {
   const idx = data.locations.findIndex((i: { id: string }) => i.id === id);
   if (idx !== -1) {
      data.locations.splice(idx, 1);
   }
};

const onAddressUpdate = (location: { address: Partial<Address> | null | undefined }, value: Partial<Address> | null | undefined) => {
   location.address = normalizeAddress(value);
};
</script>

<template>
   <LanguageTabs :errors="props.errors" v-slot="{ activeLanguageName }">
      <DraggableFormList
         v-model="model.locations"
         :add-button-label="$t('live-editor.content-blocks.location.add-location')"
         @add="addLocation(model)"
         @remove="removeLocation(model, $event)"
      >
         <template v-if="activeLanguageName" #title="{ item: location, index }">
            <h4>
               {{ location.title[activeLanguageName] || $t('live-editor.content-blocks.location.location-fallback') + ' ' + (index + 1) }}
            </h4>
         </template>
         <template v-if="activeLanguageName" #fields="{ item: location, index }">
            <div class="address-form">
               <NxtInput
                  v-model="location.title[activeLanguageName]"
                  :name="`locations[${index}].title.${activeLanguageName}`"
                  :label="$t('live-editor.content-blocks.location.name')"
                  :errors="props.errors"
               />
               <NxtAddressField
                  :model-value="location.address"
                  :name="`locations[${index}].address`"
                  :errors="props.errors"
                  @update:model-value="onAddressUpdate(location, $event)"
               />
               <NxtInput
                  v-model="location.email"
                  :name="`locations[${index}].email`"
                  type="email"
                  :label="$t('live-editor.content-blocks.location.email')"
                  :errors="props.errors"
               />
               <NxtPhoneNumberInput
                  v-model="location.phone"
                  :name="`locations[${index}].phone`"
                  :label="$t('live-editor.content-blocks.location.phone')"
               />
            </div>
         </template>
      </DraggableFormList>
   </LanguageTabs>
</template>
<style scoped lang="scss">
.address-form {
   display: flex;
   flex-direction: column;
   gap: var(--nxt-gutter);

   :deep(.nxt-address) {
      background-color: transparent;
      padding: 0;

      .nxt-address__heading {
         display: none;
      }

      .nxt-address__address {
         display: flex;
         flex-direction: column;
      }
   }
}
</style>
